export const contentTableConfig = {
  title: '客户列表',
  propList: [
    {prop: 'uname', label: '客户昵称', minWidth: '120', slotName: 'consumer', align: 'left'},
    {prop: 'isRepeat', label: '是否重复客户', minWidth: '100', slotName: 'isRepeat'},
    {prop: 'isRepeatWithinSixMonth', label: '是否6个月内重复客户', minWidth: '140', slotName: 'isRepeatWithinSixMonth'},
    {prop: 'isDeletedWithin24Hours', label: '是否24小时内删除', minWidth: '130', slotName: 'isDeletedWithin24Hours'},
    {prop: 'isInAfterSales', label: '是否在售后主体', minWidth: '120', slotName: 'isInAfterSales'},
    {prop: 'uid', label: '客户ID', minWidth: '80', align: 'left'},
    {prop: 'unionid', label: 'UnionID', minWidth: '80', align: 'left'},
    {prop: 'corpName', label: '主体名称', minWidth: '70', align: 'left'},
    {prop: 'sid', label: '账号ID', minWidth: '80', align: 'left'},
    {prop: 'usedBy', label: '使用人', minWidth: '80', align: 'left'},
    {prop: 'groupName', label: '所属组', minWidth: '80', align: 'left'},
    {prop: 'sourceLabel', label: '来源渠道', minWidth: '80', align: 'left'},
    {prop: 'thirdParty', label: '第三方', minWidth: '80'},
    {prop: 'createdAt', label: '加入时间', minWidth: '80', align: 'left', sortable: true}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
